import {CRISPRAnalysis, CRISPRRegion, DESIGN_TYPE, OFF_TARGET_SCORE_TYPE} from 'constants/CRISPRConstants';
import {SequenceVersion} from 'constants/SequenceConstants';
import * as net from 'util/Net';

interface CRISPRAnalysisCreationPayload {
  sequence: string;
  genome: string;
  crisprIaType?: 'CRISPR_I' | 'CRISPR_A';
  regions?: Array<Pick<CRISPRRegion, 'start' | 'end' | 'guides'>>;
  name: string;
  pam: string;
  isLeftPam: boolean;
  designType: DESIGN_TYPE;
  guideLength: number;
  pairOffsetMin: number;
  pairOffsetMax: number;
  aMin: number;
  aMax: number;
  tMin: number;
  tMax: number;
  cMin: number;
  cMax: number;
  gMin: number;
  gMax: number;
  offTargetScoreType: OFF_TARGET_SCORE_TYPE;
  mitOffTargetScoreWeights: string;
  pamSiteOnTargetMin: number;
  pamSiteOffTargetMin: number;
  searchSoftMaskedBases: boolean;
  useAzimuthOnTargetScore: boolean;
}

export default {
  fetchForSequence(sequenceId: string): JQueryPromise<{data: Array<CRISPRAnalysis>}> {
    return net.getJSON(`/1/api/sequences/${sequenceId}/crispr-analyses`);
  },

  create(data: CRISPRAnalysisCreationPayload): JQueryPromise<CRISPRAnalysis> {
    return net.postJSON({url: '/1/api/crispr-analyses/', data});
  },

  open(id: string): JQueryPromise<CRISPRAnalysis> {
    return net.getJSON(`/1/api/crispr-analyses/${id}`);
  },

  update(id: string, data: Partial<CRISPRAnalysisCreationPayload>): JQueryPromise<CRISPRAnalysis> {
    return net.patchJSON({url: `/1/api/crispr-analyses/${id}`, data});
  },

  delete(id: string): JQueryPromise<{}> {
    return net.delete_({url: `/1/api/crispr-analyses/${id}`});
  },

  fetchOriginalSequenceVersion(id: string): JQueryPromise<{originalSequenceVersion: null | SequenceVersion}> {
    return net.getJSON(`/1/api/crispr-analyses/${id}/original-sequence-version`);
  },
};
